/**
 * Billing Section — thin wrapper around BillingTab.
 * Gated by `ahoy_other_admin` permission (checked in nav config gate;
 * also checked here for defence-in-depth).
 */

import { usePermissions } from '@/hooks/usePermissions';
import { useViewHealthMarker } from '@/lib/view-health';

import { BillingTab } from '../../profile/components/BillingTab';
import { BILLING_ADMIN_PERMISSION } from '../settings-permissions';

export function BillingSection() {
  const { hasPermissionGroup } = usePermissions();
  const canManageBilling = hasPermissionGroup(BILLING_ADMIN_PERMISSION);
  useViewHealthMarker('settings-section-ready');

  if (!canManageBilling) {
    return null;
  }

  return (
    // The settings-layout widens to 960px when `data-wide` is present anywhere
    // in the section subtree. We don't put it here at the section root —
    // BillingTab only renders the wide 3-card PlanPicker for unsubscribed
    // orgs, so `data-wide` lives on the PlanPickerSection root itself. The
    // SubscriptionSection (post-subscribe) renders at the default 800px.
    <div className='space-y-8'>
      <div>
        <h2 className='text-lg font-semibold text-fg-primary'>Billing</h2>
        <p className='text-sm text-fg-tertiary mt-0.5'>
          Manage your subscription and payment methods.
        </p>
      </div>
      <div>
        <BillingTab />
      </div>
    </div>
  );
}
